import { X } from 'lucide-react';
import { IPresenterProps } from './types';
import * as S from './styles';

const ItemPillPresenter = (props: IPresenterProps) => {
    return (
        <S.SelectedService>
            <S.SelectedServiceName>{props.service.name}</S.SelectedServiceName>
            <S.CloseBtn onClick={() => props.removeService(props.service)}>
                <X />
            </S.CloseBtn>
        </S.SelectedService>
    );
};

export default ItemPillPresenter;
